export default __webpack_public_path__ + "static/media/Transpierce.d38bd54e.png";